import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import React, { useCallback, useMemo } from 'react';
import usePage from '#/common/hooks/usePage';
import styled from 'styled-components';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import PageButton from './PageButton';
import { DropDownButton } from 'devextreme-react';
import { color } from '@nuvolo/nuux-theme/utils';
import { PageAction } from '#/app/providers/PageProvider';

const ActionsBox = styled(NuvoBox)<{ isMobile: boolean }>`
  flex-shrink: 0;
`;

export const StyledDropDownButton = styled(DropDownButton)`
  height: 44px !important;
  border-radius: 16px !important;
  background: ${color('ui', 'light2')};
  margin: 0 !important;
  padding: 0 10px !important;

  .dx-button-content > i:nth-child(2) {
    display: none;
  }

  .dx-collection {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
`;

const PageActionsContainer: React.FC = () => {
  const { actions } = usePage();
  const { isMobile } = useViewport();

  const hidden = useMemo(() => {
    return isMobile ? actions.filter((a) => !a.alwaysShow) : [];
  }, [actions, isMobile]);

  const shown = useMemo(() => {
    return isMobile ? actions.filter((a) => a.alwaysShow) : actions;
  }, [actions, isMobile]);

  const hiddenItems = useMemo(() => {
    return hidden.map((a) => ({ ...a, disabled: !!a.props.disabled }));
  }, [hidden]);

  const handleItemClick = useCallback(async (e: any) => {
    const act = e.itemData as PageAction | undefined;
    if (act?.props.onClick) {
      act?.props.onClick(e);
    }
  }, []);

  // Force children re-render if any button is changed or hidden/shown dynamically.
  // Otherwise if we hide and then show buttons (e.g. when resizing the browser),
  //   react will put the previously hidden buttons last.
  const key = shown.map((a) => a.id).join('_');

  return (
    <ActionsBox key={key} display="flex" flexDirection="row" gap={12} isMobile={isMobile}>
      {hidden.length > 0 && (
        <StyledDropDownButton
          icon="overflow"
          stylingMode="text"
          displayExpr="props.label"
          keyExpr="id"
          items={hiddenItems}
          dropDownOptions={{ width: 200 }}
          onItemClick={handleItemClick}
        />
      )}
      {shown.map((a) => {
        switch (a.type) {
          case 'button':
            return <PageButton key={a.id} {...a.props} />;
        }
      })}
    </ActionsBox>
  );
};

export default React.memo(PageActionsContainer);
